import React from 'react';
import { X } from 'lucide-react';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../lib/supabase';
import { getRedirectUrl } from '../utils/auth';

interface SignInModalProps {
  show: boolean;
  onClose: () => void;
}

export default function SignInModal({ show, onClose }: SignInModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-md">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">Sign In</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <Auth
            supabaseClient={supabase}
            redirectTo={getRedirectUrl()}
            appearance={{
              theme: ThemeSupa,
              variables: {
                default: {
                  colors: {
                    brand: '#2563eb',
                    brandAccent: '#1d4ed8',
                  },
                },
              },
              className: {
                container: 'w-full',
                button: 'w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700',
                label: 'block text-sm font-medium text-gray-700 mb-1',
                input: 'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500',
              },
            }}
            providers={['google']}
            view="sign_in"
            showLinks={false}
          />
        </div>
      </div>
    </div>
  );
}